import { ReactComponent as Empty } from "../../src/media/unexpected_friends.svg";

const EmptyComp = ({ caption }) => {
  return (
    <div className="paddingTop20">
      <Empty className="radius2" alt="empty"></Empty>
      <h5 className="subject-1 yekan">{caption}</h5>
    </div>
  );
};
export default EmptyComp;
